export enum Portal {
    CPP = 'cpp',
    SPP = 'spp',
}

export function detectPortal(): Portal {
    const host = window.location.hostname;
    const url = window.location.href;
    if (host.startsWith('supplier.') || url.includes('spp')) {
        return Portal.SPP;
    }
    return Portal.CPP;
}
